import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../header/Header";
import Sidebarr from "../../sidebar/Sidebar";
import Tool from "../../sidebar/Tool";
import Footer from "../../footer/Footer";
import { VendorAction, vendorEdit, updateVendor } from "../../action";

/* 🔹 Required Label */
const RequiredLabel = ({ text }) => (
  <span>
    {text} <span style={{ color: "red" }}>*</span>
  </span>
);

/* 🔹 Reusable Input Component (SAME AS ADD) */
const Input = ({
  label,
  name,
  type = "text",
  register,
  errors,
  validation
}) => (
  <div className="form-group">
    <label className="col-sm-2 control-label">
      <RequiredLabel text={label} />
    </label>

    <div className="col-sm-10">
      <input
        type={type}
        className="form-control"
        {...register(name, validation)}
      />
      {errors[name] && (
        <span className="validationError">{errors[name].message}</span>
      )}
    </div>
  </div>
);

export default function EditVendor() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const vendor = useSelector((state) => state?.vendor?.editStatus);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  /* 🔹 Fetch vendor */
  useEffect(() => {
    dispatch(VendorAction());
    dispatch(vendorEdit(id));
  }, [dispatch, id]);

  /* 🔹 Pre-fill form */
  useEffect(() => {
    if (vendor) {
      reset({
        fname: vendor.fname,
        lname: vendor.lname,
        businessName: vendor.businessName,
        businessNumber: vendor.businessNumber,
        businessType: vendor.businessType,
        email: vendor.email,
        phoneNumber: vendor.phoneNumber,
        address: vendor.address,
        city: vendor.city
      });
    }
  }, [vendor, reset]);

  /* 🔹 Submit */
  const onSubmit = (data) => {
    dispatch(updateVendor({ id, ...data }));
  };

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        <Sidebarr />

        <div className="content-wrapper">
          <section className="content-header">
            <h1>Edit Brand</h1>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <Link to="/vendor" className="btn btn-success pull-right">
                  View All Brands
                </Link>
              </div>

              <div className="box-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Input
                    label="First Name"
                    name="fname"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "First Name is required"
                    }}
                  />

                  <Input
                    label="Last Name"
                    name="lname"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Last Name is required"
                    }}
                  />

                  <Input
                    label="Store Name"
                    name="businessName"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store Name is required"
                    }}
                  />

                  <Input
                    label="Store Number"
                    name="businessNumber"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store Number is required"
                    }}
                  />

                  <Input
                    label="Store URL"
                    name="businessType"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Store URL is required"
                    }}
                  />

                  <Input
                    label="Email"
                    name="email"
                    type="email"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Email is required",
                      pattern: {
                        value: /^\S+@\S+\.\S+$/,
                        message: "Invalid email address"
                      }
                    }}
                  />

                  <Input
                    label="Phone Number"
                    name="phoneNumber"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Phone Number is required",
                      minLength: {
                        value: 10,
                        message: "Minimum 10 digits required"
                      }
                    }}
                  />

                  <Input
                    label="Address"
                    name="address"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "Address is required"
                    }}
                  />

                  <Input
                    label="City"
                    name="city"
                    register={register}
                    errors={errors}
                    validation={{
                      required: "City is required"
                    }}
                  />

                  {/* 🔹 Submit */}
                  <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-10">
                      <button type="submit" className="btn btn-success">
                        Update Vendor
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
      </div>
    </div>
  );
}
